<template>
  <div class="snapshot">
    <div v-if="user_status === 2">
      <el-card class="box-card blocked-card">
        <div class="blocked">
          <div class="blocked-img">
            <img src="../assets/img/Blocked.png" alt="blocked">
          </div>
          <p class="tit">Your account has been blocked!</p>
          <p class="content">If you have any questions, please seek help from Manager.</p>
        </div>
      </el-card>
    </div>
    <div v-if="user_status !== 2">
    <el-card class="box-card" v-loading="loading" v-if="integration === 6 || channel.integration === 6">
      <el-row>
        <el-col :sm="4" :md="4" :lg="6" :xl="8">
          <span class="ym-dot pink"></span>
          <h1 class="ym-title-board">REPORT</h1>
        </el-col>
        <el-col :sm="4" :md="4" :lg="4" :xl="4" class="ym-label-board">
          <span style="bottom: 8px;font-size: 14px;">UTC+8</span>
        </el-col>
        <el-col :sm="8" :md="7" :lg="6" :xl="6">
          <el-date-picker
            v-model="dateRanges"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="to"
            start-placeholder="Start"
            end-placeholder="End"
            @change="changeDate"
            :clearable="false"
            style="width: calc(100% - 20px);"
            :picker-options="pickerOptions"
            >
          </el-date-picker>
        </el-col>
        <el-col :sm="4" :md="5" :lg="5" :xl="4">
          <el-select
            v-model="country"
            @change="getViewChart"
            filterable
            clearable
            placeholder="Select Country"
            style="width: calc(100% - 20px);"
          >
            <el-option
              v-for="(item, i) in countryList"
              :key="i"
              :label="item.code_name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :sm="4" :md="4" :lg="3" :xl="2" class="custom-button-container">
          <el-button icon="el-icon-download" @click="handleExport" style="width: 100%;">Export CSV</el-button>
        </el-col>
      </el-row>
      <div class="ym-board">
        <div class="board-data">
          <div
            class="detail-data"
            :key="index"
            v-for="(data, index) in head_data"
            :style="{
              borderLeftColor: data.color,
              borderLeftWidth: '4px',
              borderLeftStyle: 'solid',
            }"
          >
            <div class="detail-label">{{ data.name }}</div>
            <div class="detail-val">
              {{
                data.name == 'revenues' || data.name == 'cost'
                  ? formatData(data.data, ',$')
                  : formatData(data.data, ',')
              }}
            </div>
          </div>
        </div>
        <div id="chart_3"></div>
      </div>
    </el-card>
    <el-card class="box-card" v-loading="loading" v-else>
      <el-row>
        <el-col :sm="8" :md="10" :lg="10" :xl="16">
          <span class="ym-dot pink"></span>
          <h1 class="ym-title-board">REPORT</h1>
        </el-col>
        <el-col :sm="8" :md="10" :lg="10" :xl="4" class="ym-label-board">
          <span>Timezone:(GMT + 8.00)</span>
        </el-col>
        <el-col :sm="8" :md="4" :lg="4" :xl="4">
          <el-select placeholder="Time Type" @change="getViewChart" v-model="time_type">
            <el-option
              v-for="time in times"
              :value="time"
              :label="time.name"
              :key="time.name"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="ym-board">
        <div class="board-data">
          <div
            class="detail-data"
            :key="index"
            v-for="(data, index) in head_data"
            :style="{
              borderLeftColor: data.color,
              borderLeftWidth: '4px',
              borderLeftStyle: 'solid',
            }"
          >
            <div class="detail-label">{{ data.name }}</div>
            <div class="detail-val">
              {{
                data.name == 'revenues' || data.name == 'cost'
                  ? formatData(data.data, ',$')
                  : formatData(data.data, ',')
              }}
            </div>
          </div>
        </div>
        <div id="chart_1"></div>
      </div>
    </el-card>

    <el-card class="box-card" v-loading="loading" v-if="customer_type != 3 && channel.integration != 6">
      <el-row>
        <el-col :sm="8" :md="10" :lg="10" :xl="16">
          <span class="ym-dot blue"></span>
          <h1 class="ym-title-board">TOP 10 GEO REVENUES</h1>
        </el-col>
        <el-col :sm="8" :md="10" :lg="10" :xl="4" class="ym-label-board">
          <span>Timezone:(GMT + 8.00)</span>
        </el-col>
        <el-col :sm="8" :md="4" :lg="4" :xl="4">
          <el-select placeholder="Time Type" @change="getViewChart" v-model="time_type">
            <el-option
              v-for="time in times"
              :value="time"
              :label="time.name"
              :key="time.name"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <div class="ym-board">
        <div id="chart_2"></div>
      </div>
    </el-card>
    </div>
  </div>
</template>

<script>
import XLSX from 'xlsx'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/title'
import 'echarts/lib/component/markPoint'
import 'echarts/lib/component/tooltip'
import { mapGetters } from 'vuex'

export default {
  created() {
    this.user_status = this.settings.user ? this.settings.user.status : -1
    this.customer_type = this.settings.user ? this.settings.user.customer_type : -1
    this.setDefaultDateRange()
    this.time_type = this.times[0]
    this.date = new Date()
    this.times.push({ value: '4', name: 'This Month-' + this.date.toDateString().split(' ')[1] })
    // let res = {
    //     "panel": [
    //         1,
    //         2,
    //         4
    //     ],
    //     "orgtype": 3,
    //     "role": 1
    // }
    //   this.$store.dispatch('getChannelList').then(() => {
    //       this.getCommInfo(res)
    //     })
    this.loading = true
    this.$http
      .get('/api/snapshot/info-r/', {})
      .then(res => {
        this.loading = false
        this.$store.dispatch('getChannelList').then(() => {
          this.getCommInfo(res)
        })
      })
      .catch(err => {
        this.loading = false
        this.notifyOpen('Error', this.executeError(err), 'error')
      })
    this.$http.get('/api/common/get-countries-r/', {}).then(data => {
      this.countryList = data.list
    })
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          // 禁用今天之后的日期（包括今天：time.getTime() > Date.now() - 8.64e7）
          return time.getTime() > Date.now();
        }
      },
      optionData:[],
      integration:'',
      dateRanges:'',
      date: '',
      times: [
        { value: '1', name: 'Today' },
        { value: '2', name: 'Yesterday' },
        { value: '3', name: 'Last 7 Days' },
      ],
      time_type: '',
      all_data: [],
      Chart: {
        chart_1: null,
        chart_2: null,
        chart_3: null,
      },
      head_data: [],
      // hover_data:{
      //   'chart_1': [],
      //   'chart_2': [],
      // },
      loading: false,
      balance: {},
      user_status: 1,
      datesBetween:[],
      country:'',
      countryList:[
        {
          code:'ID',
          name:'Indonesia',
          label:'ID-Indonesia'
        },
        {
          code:'PH',
          name:'Philippines',
          label:'PH-Philippines'
        },
      ],
    }
  },
  computed: {
    ...mapGetters(['settings', 'aid', 'channel']),
  },
  watch: {
    aid: {
      handler(newVal, oldVal) {
        if (oldVal) {
          this.integration = this.channel.integration
          setTimeout(() => {
            this.getViewChart()
          }, 500)
        }
        this.$store.dispatch('getPerm',1).then(() => {})
      },
    },
  },
  methods: {
    exportToCSV(csvData, fileName,bookType = 'xlsx') {
      // 将数据转换为工作簿对象
      const wb = XLSX.utils.book_new();
      const ws = XLSX.utils.json_to_sheet(csvData);
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

      // 将工作簿转换为CSV字符串
      const csvOutput = XLSX.write(wb, { bookType, type: 'string' });

      // 创建Blob对象
      const blob = new Blob([csvOutput], { type: 'text/csv;charset=utf-8' });

      // 创建下载链接并模拟点击
      const downloadLink = document.createElement('a');
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    handleExport(){
      let len = this.datesBetween.length
      let arr = []
      let arr1 = this.optionData.filter(row=>row.name === 'impression')
      let arr2 = this.optionData.filter(row=>row.name === 'revenues')
      let arr3 = this.optionData.filter(row=>row.name === 'ecpm')
      let data1 = [], data2 = [], data3 = [];
      if(arr1.length > 0 && arr2.length > 0 && arr3.length > 0){
        data1 = arr1[0].data
        data2 = arr2[0].data
        data3 = arr3[0].data
        for(let i = 0;i < len;i ++){
          let obj = {
            Date: this.datesBetween[i],
            Impression: data1[i],
            Revenue: data2[i],
            eCPM: data3[i],
          }
          arr.push(obj)
        }
      }
      let startdate = this.datesBetween[0]
      let enddate = this.datesBetween[len - 1]
      let fileName = `SpinGo_Report_${startdate}_${enddate}`
      this.exportToCSV(arr, fileName,'csv');
    },
    setDefaultDateRange() {
      // const now = new Date();
      // const startOfMonth = new Date(now.getFullYear(), now.getMonth(), 1);
      // const endOfMonth = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 下个月的第一天，即本月的最后一天
      
      const now = new Date();
      const startDate = new Date(now);
      startDate.setDate(now.getDate() - 6); // 向前推6天（包含当天共7天）
      
      // // 设置日期格式为 yyyy-MM-dd
      // this.dateRanges = [
      //   this.formatDate(startOfMonth),
      //   this.formatDate(endOfMonth),
      // ];
      this.dateRanges = [
        this.formatDate(startDate),
        this.formatDate(now),
      ];
      this.getDatesBetween(this.dateRanges[0],this.dateRanges[1])
    },
    formatDate(date) {
      // 格式化日期为 yyyy-MM-dd
      return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
    },
    getDatesBetween(startDateStr, endDateStr) {
      // 将字符串日期转换为Date对象
      const startDate = new Date(startDateStr);
      const endDate = new Date(endDateStr);
      // 验证日期是否有效
      if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
          throw new Error('Invalid dates');
      }
      // 创建一个数组来存储日期
      const dateList = [];
      // 使用循环在日期之间添加每一天
      let currentDate = new Date(startDate);
      while (currentDate <= endDate) {
          // 将Date对象格式化为字符串并添加到数组中
          dateList.push(currentDate.toISOString().split('T')[0]); // 使用toISOString并截取日期部分
          // 或者使用自定义的格式化函数（这里为了简单直接使用了ISO字符串的日期部分）
          // 增加一天
          currentDate.setDate(currentDate.getDate() + 1);
      }

      this.datesBetween = dateList;
    }  ,
    changeDate(date){
      if(date && date.length === 2){
        this.getDatesBetween(date[0],date[1])
        this.getViewChart()
      }else{
        if (this.Chart['chart_3']) {
          this.Chart['chart_3'].dispose()
          this.Chart['chart_3'] = null
        }
        this.datesBetween = []
      }
    },
    getCommInfo(data) {
      let panel = data.panel
      this.orgtype = data.orgtype
      this.loadData(panel)
    },
    loadData(panel) {
      if (panel.indexOf(2) >= 0) {
        this.getViewChart()
      }
    },
    getDateIndex(index, time_length, dates) {
      let today = new Date().getDate()
      let last_month_day = 7 - today
      let k
      if (time_length === 7) {
        if (index < last_month_day) {
          k = dates - last_month_day
        } else {
          k = today - 7
        }
      } else if (time_length === 24) {
        k = -1
      } else {
        k = 0
      }
      return k
    },
    // 处理数据，填充缺失的日期
    processData(backendData, key) {
      const processedData = this.datesBetween.map(date => {
        const foundData = backendData.find(item => item.dt === date);
        let obj = {
          dt: date,
        }
        obj[key] = foundData ? foundData[key] : 0
        return obj;
      });
      return processedData;
    } ,
    getViewChart() {
      let time_type = this.time_type.value

      this.all_data = []
      this.loading = true
      let postUrl = ''
      let params = {}

      if(this.channel.integration === 6){
        postUrl = '/api/snapshot/interactive-stat-report/v2/'
        params = {
          start: this.dateRanges[0],
          end: this.dateRanges[1],
          aid: this.aid,
          country:this.country,
        }
      }else{
        postUrl = '/api/snapshot/network-stat-r/'
        params = {
          view_by: time_type,
          aid: this.aid,
        }
      }
    //   let res =  {
    //     "rpp_key": [
    //         "revenues"
    //     ],
    //     "data": {
    //         "impression": [
    //             {
    //                 "dt": "2024-07-17",
    //                 "impression": 3.0
    //             },
    //             {
    //                 "dt": "2024-07-18",
    //                 "impression": 2.0
    //             },
    //             {
    //                 "dt": "2024-07-19",
    //                 "impression": 36.0
    //             },
    //             {
    //                 "dt": "2024-07-20",
    //                 "impression": 71.0
    //             },
    //             {
    //                 "dt": "2024-07-21",
    //                 "impression": 72.0
    //             },
    //             {
    //                 "dt": "2024-07-22",
    //                 "impression": 35.0
    //             }
    //         ],
    //         "ecpm": [
    //             {
    //                 "dt": "2024-07-17",
    //                 "ecpm": "0.00"
    //             },
    //             {
    //                 "dt": "2024-07-18",
    //                 "ecpm": "0.00"
    //             },
    //             {
    //                 "dt": "2024-07-19",
    //                 "ecpm": "0.00"
    //             },
    //             {
    //                 "dt": "2024-07-20",
    //                 "ecpm": "0.00"
    //             },
    //             {
    //                 "dt": "2024-07-21",
    //                 "ecpm": "0.00"
    //             },
    //             {
    //                 "dt": "2024-07-22",
    //                 "ecpm": "0.00"
    //             }
    //         ],
    //         "rpp": [
    //             {
    //                 "dt": "2024-07-17",
    //                 "revenues": 0.0
    //             },
    //             {
    //                 "dt": "2024-07-18",
    //                 "revenues": 0.0
    //             },
    //             {
    //                 "dt": "2024-07-19",
    //                 "revenues": 0.0
    //             },
    //             {
    //                 "dt": "2024-07-20",
    //                 "revenues": 0.0
    //             },
    //             {
    //                 "dt": "2024-07-21",
    //                 "revenues": 0.0
    //             },
    //             {
    //                 "dt": "2024-07-22",
    //                 "revenues": 0.0
    //             }
    //         ]
    //     }
    // }
      this.$http
        .get(postUrl, {
          params: params,
        })
        .then(res => {
          this.loading = false
          this.network_data = res
          if (this.customer_type === 3 || this.channel.integration === 6) {
            if(this.channel.integration === 6){
              this.network_data.data.impression = this.processData(this.network_data.data.impression,'impression')
              this.network_data.data.ecpm = this.processData(this.network_data.data.ecpm,'ecpm')
              this.network_data.data.rpp = this.processData(this.network_data.data.rpp,'revenues')
              this.setChartData(this.network_data, time_type, 'impression')
              this.setChartData(this.network_data, time_type, 'ecpm')
              this.setChartData(this.network_data, time_type, 'rpp')
              this.setTable(this.all_data, 'chart_3')
            }else{
              this.setChartData(this.network_data, time_type, 'impress')
              this.setChartData(this.network_data, time_type, 'ecpm')
              this.setChartData(this.network_data, time_type, 'rpp')
              this.setChartData(this.network_data, time_type, 'clk')
              this.setTable(this.all_data, 'chart_1')
            }
          } else {
            this.setChartData(this.network_data, time_type, 'rpp')
            this.setChartData(this.network_data, time_type, 'clk')
            this.setChartData(this.network_data, time_type, 'cov')
            this.setTable(this.all_data, 'chart_1')
            this.setChartData(this.network_data, time_type, 'geo')
          }
        })
        .catch(err => {
          this.loading = false
          this.notifyOpen('Error', this.executeError(err), 'error')
        })
    },
    setChartData(data, time_type, data_type) {
      let month_dates = new Date(this.date.getFullYear(), this.date.getMonth() + 1, 0).getDate()

      let pre_month_dates = new Date(this.date.getFullYear(), this.date.getMonth(), 0).getDate()

      let time_list = [24, 24, 7, month_dates, pre_month_dates]

      let time_length;
      if(this.channel.integration === 6){
        time_length = this.datesBetween.length
      }else{
        time_length = time_list[parseInt(time_type) - 1]
      }
      let view_data = data.data[data_type]

      let total_list = []

      let chart_data = []
      this.view_data = view_data
      switch (data_type) {
        case 'rpp':
          for (let i = 0, il = data['rpp_key'].length; i < il; i++) {
            let rpp_key = data['rpp_key'][i]
            total_list.push({
              type: rpp_key,
              type_data: [],
            })
          }
          break
        case 'geo':
          if (!data['geo_key'].length) {
            total_list = [
              {
                type: '',
                type_data: [],
              },
            ]
          }
          for (let i = 0, il = data['geo_key'].length; i < il; i++) {
            let geo_key = data['geo_key'][i]
            total_list.push({
              type: geo_key,
              type_data: [],
            })
          }
          break
        case 'clk':
          total_list = [
            {
              type: 'clicks',
              type_data: [],
            },
          ]
          break
        case 'cov':
          total_list = [
            {
              type: 'conversions',
              type_data: [],
            },
          ]
          break
        case 'impress':
          total_list = [
            {
              type: 'impress',
              type_data: [],
            },
          ]
          break
        case 'impression':
          total_list = [
            {
              type: 'impression',
              type_data: [],
            },
          ]
          break
        case 'ecpm':
          total_list = [
            {
              type: 'ecpm',
              type_data: [],
            },
          ]
          break
      }
      if (!view_data.length) {
        for (let i = 0; i < time_length; i++) {
          for (let j = 0, jl = total_list.length; j < jl; j++) {
            total_list[j].type_data.push([i])
          }
        }
        chart_data = total_list
      } else {

          if (view_data.length < time_length) {
            // 数据数量少于时间长度，将数据初始化为0
            for (let i = 0; i < time_length; i++) {
              let k = this.getDateIndex(i, time_length, pre_month_dates)
              if (view_data[i]) {
                if (view_data[i].dt !== i + k + 1) {
                  view_data.splice(i + 1, 0, view_data[i])
                  view_data[i] = {}
                  view_data[i].dt = i + k + 1
                  for (let j = 0, jl = total_list.length; j < jl; j++) {
                    let key = total_list[j].type
                    view_data[i][key] = 0
                  }
                }
              } else {
                view_data[i] = {}
                view_data[i].dt = i + k + 1
                for (let j = 0, jl = total_list.length; j < jl; j++) {
                  let key = total_list[j].type
                  view_data[i][key] = 0
                }
              }
            }
          }


        for (let j = 0, jl = total_list.length; j < jl; j++) {
          let type = total_list[j]
          for (let i = 0; i < view_data.length; i++) {
            let item = view_data[i]
            type.type_data.push([i, item[type.type]])
          }
          chart_data.push(type)
        }
      }
      if (data_type !== 'geo') {
        this.all_data.push(chart_data[0])
      } else {
        this.setTable(chart_data, 'chart_2')
      }
    },
    setTable(origin_data, chart_id) {
      let chart_data = []
      let _this = this
      for (let k = 0; k < origin_data.length; k++) {
        let _chart_data = []
        let item = origin_data[k]
        _chart_data.push({
          data: item.type_data,
          label: item.type,
          lines: {},
          shadowSize: 0,
        })
        chart_data.push(_chart_data)
      }
      try {
        this.Chart[chart_id] = echarts.init(document.getElementById(chart_id))
        window.addEventListener('resize', function() {
          _this.Chart[chart_id].resize()
        })

        let option = {
          title: {
            right: 0,
            top: 0,
            subtext: 'Click the legend below to switch',
            subtextStyle: {
              align: 'right',
              color: '#c7cbd2',
            },
          },
          backgroundColor: '#FFFFFF',
          tooltip: {
            trigger: 'axis',
            confine: true,
            formatter: function(params) {
              let relVal = params[0].name
              for (let i = 0, l = params.length; i < l; i++) {
                let item = params[i]
                let val = item.value
                if (isNaN(val)) {
                  val = '-'
                }
                relVal +=
                  '<br/>' +
                  item.marker +
                  item.seriesName +
                  ' : ' +
                  (item.seriesName === 'revenues' ? '$' + val : val)
              }
              return relVal
            },
          },
          color: [
            '#FB5B94',
            '#A980FF',
            '#2CB5FF',
            '#c1232b',
            '#27727b',
            '#fcce10',
            '#e87c25',
            '#b5c334',
            '#fe8463',
            '#9bca63',
            '#fad860',
          ],
          legend: {
            data: [],
            selected: {},
            top: '10%',
            right: '0%',
            show: true,
            itemGap: 30,
          },
          grid: {
            left: '3%',
            top: '80',
            right: '4%',
            bottom: '0',
            containLabel: true,
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: [],
            axisTick: {
              show: false,
            },
            axisLine: {
              lineStyle: {
                color: '#EEF0F6',
                width: 2,
                type: 'solid',
              },
            },
            axisLabel: {
              color: '#323339',
              fontSize: '12',
              fontWeight: 400,
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#EEF0F6',
                width: 1,
              },
            },
          },
          yAxis: {
            type: 'value',
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLabel: {
              formatter: '{value} ',
            },
          },
          series: [],
        }
        this.Chart[chart_id].clear(this.option);
        if (chart_id === 'chart_1' || chart_id === 'chart_3') {
          this.head_data = []
          for (let i = 0; i < this.all_data.length; i++) {
            let item = this.all_data[i]
            let name = item.type
            let type_data = item.type_data
            let data = 0
            let color = option.color[i]
            if (name === 'ecpm') {
              continue
            }
            for (let k = 0; k < type_data.length; k++) {
              if (type_data[k][1]) {
                data += Number(type_data[k][1])
              }
            }
            this.head_data.push({
              name: name,
              data: data,
              color: color,
            })
          }
          let revenues = 0
          let clicks = 0
          let impress = 0
          let impression = 0
          for (let i = 0; i < this.head_data.length; i++) {
            if (this.head_data[i].name === 'revenues') {
              this.head_data[i].data = this.head_data[i].data.toFixed(2)
              revenues = this.head_data[i].data
            }
            if (this.head_data[i].name === 'cost') {
              this.head_data[i].data = this.head_data[i].data.toFixed(2)
            }
            if (this.head_data[i].name === 'clicks') {
              clicks = this.head_data[i].data
            }
            if (this.head_data[i].name === 'impress') {
              impress = this.head_data[i].data
            }
            if (this.head_data[i].name === 'impression') {
              impression = this.head_data[i].data
            }
          }
          for (let i = 0; i < this.all_data.length; i++) {
            let item = this.all_data[i]
            let name = item.type
            let color = option.color[i]
            if (name === 'ecpm') {
              if(this.channel.integration === 6){
                let num = 0
                if(revenues > 0 && impression > 0){
                  num = (revenues * 1000) / impression
                }
                if(num > 0){
                  num = num.toFixed(2)
                }
                this.head_data.push({
                  name: name,
                  data: num ? num : '-',
                  color: color,
                })
              }else{
                this.head_data.push({
                  name: name,
                  data: (revenues / clicks) * 1000 ? (revenues / clicks) * 1000 : '-',
                  color: color,
                })
              }
            }
          }
        }

        for (let k = 0; k < chart_data.length; k++) {
          let line_data = chart_data[k][0]
          let series = {
            name: line_data.label,
            type: 'line',
            data: [],
          }

          let x_ticks = []
          if(this.channel.integration === 6){
            for (let i = 0; i < line_data.data.length; i++) {
              series.data.push(Number(line_data.data[i][1]))
              x_ticks.push(this.datesBetween[i])
            }
          }else{
            for (let i = 0; i < line_data.data.length; i++) {
              series.data.push(Number(line_data.data[i][1]))
              if (line_data.data.length !== 24) {
                // 单位不为日的,x轴序号从1开始
                x_ticks.push(line_data.data[i][0] + 1)
              } else {
                x_ticks.push(line_data.data[i][0])
              }
            }
          }
          option.series.push(series)
          option.legend.data.push(series.name)
          option.legend.selected[series.name] =
            series.name !== 'clicks' && series.name !== 'conversions'
          option.xAxis.data = x_ticks
        }
        this.optionData = option.series
        this.Chart[chart_id].setOption(option)
      } catch (error) {}
    },
  },
}
</script>

<style lang="scss">
.snapshot {
  .custom-button-container .el-icon-download::before {
    color: #0080CC;
    font-weight: bold;
  }
  #chart_1 {
    height: 340px;
    width: 100%;
  }
  #chart_2 {
    height: 340px;
    width: 100%;
  }
  #chart_3 {
    height: 340px;
    width: 100%;
  }
  .el-card {
    margin-bottom: 24px;
    .el-card__body {
      padding-bottom: 50px;
    }
  }
  .ym-board {
    position: relative;
  }
  .ym-title-board {
    display: inline-block;
    margin-left: 16px;
    font-size: 16px;
    font-weight: 400;
  }
  .ym-label-board {
    position: relative;
    height: 32px;
    font-size: 12px;
    font-weight: 400;
    color: rgba(199, 203, 210, 1);
  }
  .ym-label-board span {
    position: absolute;
    right: 20px;
    bottom: 0;
  }
  .detail-label {
    text-transform: capitalize;
    font-size: 12px;
    font-weight: 400;
    color: rgba(155, 158, 163, 1);
  }
  .detail-val {
    font-size: 20px;
    font-weight: 500;
    color: rgba(55, 56, 58, 1);
  }
  .board-data {
    position: absolute;
    z-index: 9;
  }
  .detail-data {
    display: inline-block;
    width: 200px;
    padding-left: 16px;
    height: 40px;
  }
  .blocked-card{
    min-height: 700px;
  }
  .blocked{
    text-align: center;
    line-height: 1.5;
    .blocked-img{
      width: 170px;
      margin: 40px auto 16px;
      img{
        width: 100%;
        height: auto;
      }
    }
    .tit{
      color: #3F4042;
      font-weight: 600;
    }
    .content{
      font-size: 14px;
      color: #606266;
      margin-top: 4px;
    }
  }
}
</style>
